import { cn } from 'design-system'
import { Copy } from 'lucide-react'
import { FC, Ref, CSSProperties, PropsWithChildren } from 'react'
import { useDispatch } from 'react-redux'

import { constants as snackbarConstants } from 'src/components/generics/snackbar'
import { copy } from 'src/lib/util/clipboard'
import * as snackbarSlice from 'src/store/snackbar'

type ClipboardCopyButtonProps = {
  label: string
  text: string
  className?: string
  style?: CSSProperties
  onCopy?: () => void
  successMsg?: string
  ref?: Ref<HTMLButtonElement>
}

export const ClipboardCopyButton: FC<
  PropsWithChildren<ClipboardCopyButtonProps>
> = ({
  label,
  text,
  className,
  style,
  onCopy,
  successMsg = 'Copied to clipboard!',
  children,
  ref
}) => {
  const dispatch = useDispatch()

  const setMessage = (opts: $TSFixMe) =>
    dispatch(snackbarSlice.actions.openSnackbar(opts))

  const handleClick = () =>
    copy(text)?.then(() => {
      setMessage({
        msg: successMsg || 'Copied to clipboard!',
        type: snackbarConstants.types.SUCCESS
      })

      if (typeof onCopy === 'function') {
        onCopy()
      }
    })

  return (
    <button
      ref={ref}
      type="button"
      onClick={handleClick}
      aria-label={label}
      style={style}
      className={cn(
        'cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500',
        className
      )}>
      {children || <Copy size={16} aria-hidden="true" />}
    </button>
  )
}
